import { useEffect } from "react";
import { useSelector } from "react-redux";
import Chart from "react-apexcharts";
import { useDashboardStore } from "../../../hooks";
import { LoadingData, ErrorMessage } from "../../ui";
import { optionsHyperbaricChamberSessions } from "../../data";

export const HyperbaricChamberSessionsChart = () => {
  // Datos del hook ----------------------------------------//
  const { isLoading, data, errorMessage } = useSelector(
    (state) => state.dashboard.hyperbaricChamberSessions
  );

  const { getDataHyperbaricChamberSessions } = useDashboardStore();
  // States ------------------------------------------------//
  // Formulario --------------------------------------------//
  // Funciones ---------------------------------------------//
  // Efectos -----------------------------------------------//
  useEffect(() => {
    if (!data) {
      getDataHyperbaricChamberSessions();
    }
  }, [data, getDataHyperbaricChamberSessions]);

  return (
    <div className="card shadow border-0 p-4 h-100">
      {isLoading && <LoadingData />}
      {errorMessage && <ErrorMessage>{errorMessage}</ErrorMessage>}
      {data && (
        <>
          <h6 className="align-items-center mb-0">
            Número de sesiones de camaras hiperbaricas por mes
          </h6>
          <Chart
            options={optionsHyperbaricChamberSessions}
            series={data.series}
            type="bar"
            width="100%"
            height={350}
          />
        </>
      )}
    </div>
  );
};
